import React, { useContext, useEffect, useState } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import "../../../css/login/login.css";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../button/ButtonWhite";
import ButtonBack from "../../button/ButtonBack";
import InputLogin from "../../inputs/InputLogin";
import SelectPhone from "../../../components/select/selectPhone";
import SearchableSelect from "../../../components/select/SearchableSelect";
import { formatPhoneNumber } from '../../../utils/FormatPhoneNumber'
import { validateEmail } from "../../../utils/VaidateEmail";

const RegistreCompany = ({
  RegisterCompanyFetch,
  onPressReturn,
  listCountry,
  setCountry,
  setFirstName,
  setLastName,
  setPhone,
  setEmail,
  setPassword,
  setPhoneCode,
  loading = false,
  errorMesagge,
  phone,
  setSelectOnboarding,
  errorFirtsName,
  errorLastName,
  errorContry,
  errorEmail,
  errorPrefijo,
  errorPhone,
  errorPassword

}) => {
  const { language } = useContext(UtilContext);


  const [formattedPhone, setFormattedPhone] = useState(phone);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const [email, setEmailValue] = useState("");

  const [countryFilter, setCountryFilter] = useState([]); // Estado para guardar los países filtrados
  const selectedCodes = ["CO", "US"]; // Códigos seleccionados

  // Función para filtrar países por código
  const filterByCodes = (codes) => {
    return listCountry.filter((country) => codes.includes(country.code));
  };

  const handlePhoneChange = (value) => {
    // Formatear el número de teléfono
    const formatted = formatPhoneNumber(value);
    setFormattedPhone(formatted);

    // Obtener solo los números del valor formateado
    const numericValue = formatted.replace(/\D/g, "");

    // Validar que el número tenga entre 8 y 11 dígitos
    if (numericValue.length >= 8 && numericValue.length <= 11) {
      setPhone(numericValue);
    } else {
      setPhone("");
    }
  };
  const handleEmailChange = (value) => {
    setEmailValue(value);
    setEmail(value);
  };

  const handleRegister = () => {
    RegisterCompanyFetch();
    setIsSubmitPressed(true);
    setIsEmailValid(validateEmail(email));
  };

  useEffect(() => {
    if (listCountry) {
      const filteredCountries = filterByCodes(selectedCodes);
      setCountryFilter(filteredCountries);
    }
  }, [listCountry]);

  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-full md:w-3/4 flex justify-evenly flex-col"
    >
      <div className="flex flex-col gap-2">
        <p className="text-2xl md:text-3xl mb-2 mt-6" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].registre_company.title}
        </p>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col md:flex-row w-full gap-2">
            <div className="w-full md:w-1/2">
              <p style={{ color: ColorsMain.bgLogin }}>
                {GLOBAL_LANGUAGE[language].registre_company.label_firts_name}
              </p>
              <InputLogin
                error={errorFirtsName}
                onChange={(value) => setFirstName(value)}
                placeholder={GLOBAL_LANGUAGE[language].registre_company.placeholder_firts_name}
              />
            </div>
            <div className="w-full md:w-1/2">
              <p style={{ color: ColorsMain.bgLogin }}>
                {GLOBAL_LANGUAGE[language].registre_company.label_last_name}
              </p>
              <InputLogin
                onChange={(value) => setLastName(value)}
                error={errorLastName}
                placeholder={GLOBAL_LANGUAGE[language].registre_company.placeholder_last_name}
              />
            </div>
          </div>

          <p style={{ color: ColorsMain.bgLogin }}>
            {GLOBAL_LANGUAGE[language].registre_company.label_email}
          </p>
          <InputLogin
            value={email}
            onChange={handleEmailChange}
            error={!isEmailValid ? "Por favor ingrese un correo electrónico válido." : errorEmail}
            placeholder={GLOBAL_LANGUAGE[language].registre_company.placeholder_email}
          />
          {!isEmailValid && (
            <div className="w-full flex flex-col">
              <p className="text-[#FF928B] text-[13px]">
                {GLOBAL_LANGUAGE[language].registre_company.error_email}
              </p>
            </div>
          )}
          <p style={{ color: ColorsMain.bgLogin }}>
            {GLOBAL_LANGUAGE[language].registre_company.label_phone}
          </p>
          <div className="flex flex-row w-full gap-1">
            <div className="">
              <SelectPhone error={errorPrefijo} setValue={setPhoneCode} list={listCountry} />
            </div>
            <div className="flex-1">
              <InputLogin
                error={errorPhone}
                onChange={handlePhoneChange}
                value={formattedPhone}
                placeholder={GLOBAL_LANGUAGE[language].registre_company.placeholder_phone}
              />
            </div>
          </div>
          {errorPhone && (
            <div className="w-full flex">
              <p className="text-[#FF928B] text-[13px]">{errorMesagge}</p>
            </div>
          )}
          <p style={{ color: ColorsMain.bgLogin }}>
            {GLOBAL_LANGUAGE[language].registre_company.label_pais}
          </p>
          <SearchableSelect error={errorContry} setValue={setPhoneCode} image list={listCountry} setSelectOpcion={setCountry} />

          {/*  <p style={{ color: ColorsMain.bgLogin }}>
            {GLOBAL_LANGUAGE[language].registre_company.contry_onboarding}
          </p>
          <SearchableSelect error={errorContry} image list={countryFilter} setSelectOpcion={setSelectOnboarding} /> */}
          <p style={{ color: ColorsMain.bgLogin }}>
            {GLOBAL_LANGUAGE[language].registre_company.label_password}
          </p>
          <div>
            <InputLogin
              error={errorPassword}
              onChange={(value) => setPassword(value)}
              placeholder={GLOBAL_LANGUAGE[language].registre_company.placeholder_password}
              password={true}
            />
            <p style={{ color: ColorsMain.bgLogin, fontSize: 12 }}>
              {GLOBAL_LANGUAGE[language].registre_company.subtitle_password}
            </p>
          </div>
          {(errorMesagge || errorPassword) && (
            <div className="w-full flex flex-col">
              <p className="text-[#FF928B] text-[13px]">{errorMesagge}</p>
            </div>
          )}
        </div>
        <div className="flex flex-col-reverse md:flex-row w-full justify-between gap-4 mt-4">
          <ButtonBack
            onClick={onPressReturn}
            label={GLOBAL_LANGUAGE[language].registre_company.label_back}
            className="w-full md:w-[160px]"
          />
          <ButtonWhite
            loading={loading}
            onClick={handleRegister}
            label={GLOBAL_LANGUAGE[language].registre_company.label_continue}
            className="w-full md:w-[160px]"
          />
        </div>
      </div>
      <div className="w-full border-t-2 border-[#5E5E63] mt-8 md:mt-12"></div>
      <div className="flex flex-row justify-between mt-4">
        <div className="flex justify-center">
          <p className="text-sm cursor-pointer inline-block border-b-2 border-current">
            <a >
              {GLOBAL_LANGUAGE[language].registre_company.label_acount}
            </a>
          </p>
        </div>
        <div className="flex justify-center">
          <p className="text-sm cursor-pointer inline-block border-b-2 border-current">
            <a href="https://www.colurs.io/terminos/" target="_blank">
              {GLOBAL_LANGUAGE[language].registre_company.terminos_condiciones}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistreCompany;